class TextWithLinkBlock extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const anchor = this.querySelector('a[data-scroll-to-anchor]');
    
    if (!anchor) {
      return;
    }

    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      
      const targetId = anchor.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (!targetElement) {
        console.warn(`Target element with id "${targetId}" not found`);
        return;
      }

      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 125;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } else {
        targetElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }
}

if (typeof customElements.get('text-with-link-block') === 'undefined') {
  customElements.define('text-with-link-block', TextWithLinkBlock);
}